export const ERR_INVALID_ADDR = '_ERR_INVALID_ADDR'
export const ERR_PAYMENT_FAILED = 'PAYMENT_FAILED'
export const ERR_MISSING_BILLING_ADDRESS = 'ERR_MISSING_BILLING_ADDRESS'
